import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { useModal } from "@root/client/modal";
import { Safeguard } from "@scenes/safeguard";
import { Props } from "./types";
import { MaterialResourceIcon } from "./materialResourceIcon";
import { VirtualResourceIcon } from "./virtualResourceIcon";
import { InviteMembersIcon } from "./inviteMembersIcon";
import styles from "./styles.scss";

function Menu(_: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { pushView } = useModal();

  return (
    <Safeguard
      useCases={[
        UseCases.addPlanzoneMaterialResource,
        UseCases.inviteMembers,
        UseCases.addPlanzoneVirtualResource,
      ]}
    >
      {({
        canAddPlanzoneMaterialResource,
        canAddPlanzoneVirtualResource,
        canInviteMembers,
      }) =>
        (canAddPlanzoneMaterialResource ||
          canAddPlanzoneVirtualResource ||
          canInviteMembers) && (
          <VisibilityWatcher>
            {(isVisible, show, hide) => (
              <div className={styles.menu}>
                <button
                  className={styles.addResourceButton}
                  onClick={isVisible ? hide : show}
                >
                  <div className={styles.iconBox}>+</div>
                  <p>{t("planzoneMembersPage.addResource")}</p>
                </button>
                {isVisible && (
                  <div className={styles.list}>
                    {canInviteMembers &&
                      planzone.uuid !==
                        "4e5b940a-9c6c-4a71-9507-77dc519b4e97" && (
                        <div
                          className={styles.item}
                          onClick={() => {
                            pushView({
                              data: undefined,
                              key: UseCases.inviteMembers,
                            });
                            hide();
                          }}
                        >
                          <InviteMembersIcon className={styles.icon} />
                          <p className={styles.name}>
                            {t("planzoneMembersPage.inviteMembers")}
                          </p>
                        </div>
                      )}
                    {canAddPlanzoneVirtualResource && (
                      <div
                        className={styles.item}
                        onClick={() => {
                          pushView({
                            data: undefined,
                            key: UseCases.addPlanzoneVirtualResource,
                          });
                          hide();
                        }}
                      >
                        <VirtualResourceIcon className={styles.icon} />
                        <p className={styles.name}>
                          {t("planzoneMembersPage.addVirtualResource")}
                        </p>
                      </div>
                    )}
                    {canAddPlanzoneMaterialResource && (
                      <div
                        className={styles.item}
                        onClick={() => {
                          pushView({
                            data: undefined,
                            key: UseCases.addPlanzoneMaterialResource,
                          });
                          hide();
                        }}
                      >
                        <MaterialResourceIcon className={styles.icon} />
                        <p className={styles.name}>
                          {t("planzoneMembersPage.addMaterialResource")}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </VisibilityWatcher>
        )
      }
    </Safeguard>
  );
}

export { Menu };
